export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00559.9fd60ef9.png";